const upsColorConfiguration = {
  primaryColor: '#330000',
  secondaryColor: '#00857D',
  normalFillColor: '#330000',
}

export default upsColorConfiguration
